import { render, staticRenderFns } from "./OnboardingDlg.vue?vue&type=template&id=1504cca8"
import script from "./OnboardingDlg.vue?vue&type=script&lang=ts"
export * from "./OnboardingDlg.vue?vue&type=script&lang=ts"
import style0 from "./OnboardingDlg.vue?vue&type=style&index=0&id=1504cca8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports